import React, { useId } from 'react'
import PropTypes from 'prop-types'

const Group2Icon = React.forwardRef(function Group2Icon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M23.19 14.92C20.64 14.4 20.09 13.34 20.01 12.31C21.32 11.33 22 9.47 22 8V6C22 3.24 19.76 1 17 1C15.37 1 13.87 1.78 12.94 3.08C12.64 3.03 12.32 3 12 3C10.44 3 9.02 3.6 7.95 4.58C7.11 3.6 5.86 3 4.5 3C2.02 3 -5.96046e-08 4.99 -5.96046e-08 7.43V8.57C-5.96046e-08 10.05 0.75 11.35 1.88 12.16C1.48 13.25 0.81 14.77 0.29 15.29C-0.1 15.68 -0.1 16.31 0.29 16.7C0.49 16.9 0.74 17 1 17C1.26 17 1.51 16.9 1.71 16.71C2.58 15.84 3.36 13.93 3.74 12.93C3.98 12.97 4.24 13 4.5 13C5.11 13 5.69 12.88 6.24 12.66C6.57 13.81 7.23 14.82 8.12 15.57C8.05 15.69 8.01 15.83 8 15.97C8 16.02 7.9 17.31 5.68 18.05C3.77 18.69 2 19.61 2 22C2 22.55 2.45 23 3 23C3.55 23 4 22.55 4 22C4 21.13 4.35 20.61 6.32 19.95C8.93 19.08 9.69 17.49 9.91 16.62C10.56 16.86 11.26 17 12 17C12.74 17 13.44 16.86 14.09 16.62C14.31 17.49 15.07 19.08 17.68 19.95C19.65 20.61 20 21.13 20 22C20 22.55 20.45 23 21 23C21.55 23 22 22.55 22 22C22 19.61 20.23 18.69 18.32 18.05C16.1 17.31 16 16.03 16 16C16 15.84 15.95 15.7 15.89 15.56C16.7 14.87 17.32 13.96 17.68 12.93C17.78 12.97 17.88 13 18 13C18.03 13 18.06 12.99 18.09 12.99C18.47 15.01 20.04 16.31 22.79 16.87C22.86 16.88 22.92 16.89 22.99 16.89C23.46 16.89 23.87 16.56 23.97 16.09C24.08 15.56 23.73 15.03 23.19 14.92ZM2 8.57V7.43C2 6.09 3.12 5 4.5 5C5.42 5 6.23 5.5 6.67 6.26C6.24 7.09 6 8.01 6 9V10.5C5.57 10.82 5.05 11 4.5 11C3.12 11 2 9.91 2 8.57ZM16 11C16 13.21 14.21 15 12 15C9.79 15 8 13.21 8 11V9C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9V11ZM14.97 3.79C15.52 3.29 16.23 3 17 3C18.65 3 20 4.35 20 6V8C20 9.02 19.29 11 18 11V9C18 6.77 16.78 4.83 14.97 3.79Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

Group2Icon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

Group2Icon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default Group2Icon
